import { render } from "./ContactSection.vue?vue&type=template&id=1df92179&scoped=true"
const script = {}

import "./ContactSection.vue?vue&type=style&index=0&id=1df92179&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df92179"]])

export default __exports__